<div class="divisor20"></div>
<div>
    <div class="divisor8"></div>
    <div class="row">
        <div class="col-lg-12 col-lg-12 col-sm-12 col-12">
            <!-- Hijos -->
            <div class="row">
                <div class="col-12">
                    <span class="labelDescripcionGris">Puestos asignados al colaborador actualmente</span>
                </div>
            </div>

            <div class="divisor20" *ngIf="!disabled"></div>
            <div class="row" *ngIf="!disabled">
                <div class="col-12">
                    <div class="panelBotonesFiltro mixto">
                        <button  class="btn boton botonXS" (click)="Modal()">
                            <span class="fa fa-plus"></span>
                            <span> {{'Agregar'}}</span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="divisor16"></div>

            <div class="row">
                <div class="col-12">
                    <!-- datos -->
                    <dx-data-grid
                        id="tabla"
                        [columnAutoWidth]="true"
                        [dataSource]="dataTable"
                        [showColumnHeaders]="true"
                        >

                        <dxi-column *ngIf="!disabled"
                            [allowExporting]="false"
                            caption="Acciones"
                            cellTemplate="cellAcciones"
                            alignment="center">

                        </dxi-column>
                        <dxi-column
                            dataField="puesto"
                            caption="Puesto">
                        </dxi-column>
                        <dxi-column
                            dataField="puestosuperior"
                            caption="Puesto superior">
                        </dxi-column>
                        <dxi-column
                            dataField="fechaasignado"
                            caption="Fecha de asignación"
                            dataType="date"
                            format="dd/MM/yyyy">
                        </dxi-column>
                        <dxi-column
                            dataField="usuarioasignado"
                            caption="Asignado por">
                        </dxi-column>
                        <dxi-column
                            dataField="antiguedad"
                            caption="Antigüedad">
                        </dxi-column>

                        <!-- Acciones -->
                        <div *dxTemplate="let cell of 'cellAcciones'">
                            <a matTooltip="Baja" class="tablaBoton separado edit" (click)="Baja(cell.data)">
                                <i class="fa fa-level-down fa-lg" aria-hidden="true"></i>
                            </a>
                            <a matTooltip="Eliminar" class="tablaBoton separado delete" (click)="Eliminar(cell.data)">
                                <i class="fa fa-trash fa-lg" aria-hidden="true"></i>
                            </a>
                        </div>

                    </dx-data-grid>
                </div>
            </div>
            <div class="divisor48"></div>
            <div class="divisorgris"></div>
            <div class="divisor48"></div>

            <div class="row">
                <div class="col-12">
                    <span class="labelDescripcionGris">Histórico de puestos asignados al colaborador</span>
                </div>
            </div>
            <div class="divisor16"></div>
            <div class="row">
                <div class="col-12">
                    <!-- datos -->
                    <dx-data-grid
                        id="tabla"
                        [columnAutoWidth]="true"
                        [dataSource]="dataTable2"
                        [showColumnHeaders]="true"
                        >

                       <dxi-column *ngIf="!disabled"
                            [allowExporting]="false"
                            caption="Acciones"
                            cellTemplate="cellAcciones"
                            alignment="center">
                        </dxi-column>
                        <dxi-column
                            dataField="puesto"
                            caption="Puesto">
                        </dxi-column>
                        <dxi-column
                            dataField="puestosuperior"
                            caption="Puesto superior">
                        </dxi-column>
                        <dxi-column
                            dataField="fechaasignado"
                            caption="Fecha de asignación"
                            dataType="date"
                            format="dd/MM/yyyy">
                        </dxi-column>
                        <dxi-column
                            dataField="usuarioasignado"
                            caption="Asignado por">
                        </dxi-column>
                        <dxi-column
                            dataField="fechaeliminado"
                            caption="Fecha de eliminado"
                            dataType="date"
                            format="dd/MM/yyyy">
                        </dxi-column>
                        <dxi-column
                            dataField="usuarioeliminado"
                            caption="Eliminado por">
                        </dxi-column>
                        <dxi-column
                            dataField="antiguedad"
                            caption="Antigüedad">
                        </dxi-column>

                        <!-- Acciones -->
                        <div *dxTemplate="let cell of 'cellAcciones'">
                            <a matTooltip="Eliminar" class="tablaBoton separado delete" (click)="Eliminar(cell.data)">
                                <i class="fa fa-trash fa-lg" aria-hidden="true"></i>
                            </a>
                        </div>

                    </dx-data-grid>
                </div>
            </div>

        </div>
    </div>
</div>

<ng-container *ngIf="abierto">
    <div class="backdrop"></div>
    <div class="modalPanelAdmin small animated {{animacion}}">

        <div class="contenido">
            <!-- Título -->
            <div class="encabezadoModal">
                <div class="modalTituloSimple">
                    {{(entidad.puestoporcolaboradorid == 0 ? 'Agregar' : 'Editar')}}
                </div>
            </div>
            <div class="modalContenido">
                <!-- datos -->
                <div>
                    <div class="divisor8"></div>
                    <div>
                        <!-- Datos generales -->
                        <div class="row">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                                <dropdownCustom [titulo]="'Seleccionar puesto(s) que desea asignar al colaborador'" 
                                    [(ngModel)]="entidad.puestoid" 
                                    [opciones]="SelPuesto"
                                    [valorName]="'puestoid'"
                                    [displayValor]="'nombre'"
                                    [errorActivo]="errorActivo"
                                    [multiSelect]="true"
                                    ></dropdownCustom>
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                                <datePickerV2Custom [titulo]="'Fecha de asignación'" [(ngModel)]="entidad.fechaasignado" [errorActivo]="errorActivo"></datePickerV2Custom>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <!-- footer -->
            <div class="modalFooter">
                <div class="contenidoFooter botonesIzq">
                    <!-- editar -->
                    <div class="botonDerecha">
                        <button class="boton botonSM filledBlanco" (click)="CerrarModal()">
                            {{'Cancelar' | translate}}
                        </button>
                        <div class="divisorH16"></div>
                        <button class="boton botonSM filled" (click)="Guardar()">
                            {{'Guardar' | translate}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>